export var ISSUE_TYPES;
(function (ISSUE_TYPES) {
    ISSUE_TYPES["ERRORS"] = "errors";
    ISSUE_TYPES["WARNINGS"] = "warnings";
})(ISSUE_TYPES || (ISSUE_TYPES = {}));
export const HANDLED_ERRORS = [400, 403, 404, 500, 501, 502];
